import { QueryClient } from '@tanstack/react-query';
let queryClient: QueryClient | null = null;

// Refactor so that query client is reusable in both app and potentially loaders in react router
function getQueryClient() {
    if (typeof window === 'undefined') {
        // Server-side: always create a new instance
        return new QueryClient();
    }

    if (!queryClient) {
        // Client-side: create a new instance only if it doesn't exist
        queryClient = new QueryClient();
    }

    return queryClient;
}

export const createQueryClient = () => {
    return getQueryClient();
};
